const Drawing = () => import('@/pages/income/Drawing.vue');

export default [
  {
    path: '/income/drawing',
    name: 'incomeDrawing',
    component: Drawing,
  },
]